import React, { useEffect, useMemo, useState } from "react";
import {
  Header,
  Table,
  Loader,
  Dimmer,
  Button,
  Icon,
  Dropdown,
  Form,
  FormGroup,
  FormField
} from "semantic-ui-react";
import CardLayout from '../common/CardLayout';
import { filterVitalSignTypeByAge, getTableRowVitalSign } from "../HISV3/PTM/CardVitalSign";
import { SORT_ADR_ORDER } from "react-lib/apps/HISV3/TPD/sequence/Allergy";
import { formatDatetime } from "react-lib/utils/dateUtils";
import { useIntl } from "react-intl";
import CheckupReportSerializer from "issara-sdk/types/CheckupReportSerializer_core";

const LANGUAGE_OPTIONS = [
  { key: "th", value: "th", text: "TH" },
  { key: "en", value: "en", text: "EN" },
];

const EMRRowTable = ({ name, value }) => {

  let p = value.split("\n");
  let dict = {};
  let currentKey = "";

  if (value.includes(":")) {
    p.forEach((item, index) => {
      // Found Lab
      if (item.startsWith("-")) {
        let key = item.slice(1);
        key = key.slice(0, -1);
        key.trim();

        currentKey = key;
        dict[key] = [];
      } else {
        let itemTrimed = item.trim();

        let labCode = "";
        let labName = "";
        let resultLab = "";

        if (itemTrimed.startsWith("1.") && dict[currentKey].length > 0) {
          dict[currentKey].push({ labCode, labName, resultLab });
        }

        if (!currentKey.includes("ray")) {
          labCode = itemTrimed.match(/\[(.*?)]/)[1].trim();
          labName = itemTrimed.match(/](.*?)=/)[1].trim();
          resultLab = itemTrimed.match(/=(.*?)$/)[1].trim();
        } else {
          labName = itemTrimed.match(/](.*?)=/)[1].trim();
          resultLab = itemTrimed.match(/=(.*?)$/)[1].trim();
        }

        dict[currentKey].push({ labCode, labName, resultLab });
      }
    });
  }

  return (
    <Table.Row>
      <Table.Cell width={3}>
        <Header as="h5"> {name} </Header>
      </Table.Cell>
      {dict && Object.keys(dict).length > 0 ? (
        <Table.Cell width={13}>
          {
            Object.keys(dict).map((key, index) => {
              return (

                <Table compact key={key} color={"red"}>
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell colSpan={3}>{key}</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>

                  <Table.Body>
                    {dict[key].map(item => {
                      if (!key.includes("ray")) {
                        return (
                          <>
                            <Table.Row key={item.labCode}>
                              <Table.Cell width={5}>
                                {" "}
                                {item.labCode}{" "}
                              </Table.Cell>
                              <Table.Cell width={6}>
                                {" "}
                                {item.labName}{" "}
                              </Table.Cell>
                              <Table.Cell width={5}>
                                {" "}
                                {item.resultLab}
                              </Table.Cell>
                            </Table.Row>
                          </>
                        );
                      } else {
                        return (
                          <>
                            <Table.Row key={item.labCode}>
                              <Table.Cell width={6}>
                                {" "}
                                {item.labName}{" "}
                              </Table.Cell>
                              <Table.Cell width={10}>
                                {" "}
                                {item.resultLab}{" "}
                              </Table.Cell>
                            </Table.Row>
                          </>
                        );
                      }
                    })}
                  </Table.Body>
                </Table>

              );
            })
          }
        </Table.Cell>
      ) : (
        <Table.Cell width={13}> {value} </Table.Cell>
      )}
    </Table.Row>
  );
};

const EMRRowTablePhysical = ({ name, value }) => {
  console.log('EMRRowTablePhysical name: ', name );
  console.log('EMRRowTablePhysical value: ', value );
  let dict = null;
  if (value.includes("(")) {
    let l = value.split(",");
    l.reverse().forEach((item, index) => {
      if (!item.includes("(")) {
        let i = index + 1;
        if (i <= l.length) {
          l[i] = l[i].concat(",", l[index]);
        }
      } else {
        l[index] = item.trim();
      }
    });

    l = l.reverse().filter(item => {
      if (!item.includes("(")) {
        return false;
      } else {
        return true;
      }
    });
    //  let g = ["GA(N/A)", " HEENT(Normal): pharynx and tonsils not injected↵LN not palpable", " CVS(N/A)", " Chest(Normal): clear", " Abdomen(Normal): soft, mild tender suprapubic, CVA not tender", " Ext(Normal): no arthritis", " LN(N/A)", " Skin(N/A)", " NS(N/A)"]
    //  let g = ["GA(N/A)", " HEENT(Normal): pharynx and tonsils not A(ON): injected↵LN not palpable", " CVS(N/A)", " Chest(Normal): clear", " Abdomen(Normal): soft, mild tender suprapubic, CVA not tender", " Ext(Normal): no arthritis", " LN(N/A)", " Skin(N/A)", " NS(N/A)"]
    dict = l.map(item => {
      let column = item.split(":");
      let one = column[0].split("(");
      let two = one && one.length > 1 ? one[1].slice(0, -1) : '';
      column.shift();
      let three = column.join(":");

      return { organ: one[0], status: two, description: three };
    });
  }

  return (
    <Table.Row key={name}>
      <Table.Cell width={3}>
        <Header as="h5"> {name} </Header>
      </Table.Cell>
      {dict ? (
        <Table.Cell width={13}>
          <Table compact>
            <Table.Body>
              {dict.map(item => {
                return (
                  <Table.Row key={item.organ}>
                    <Table.Cell width={5}> {item.organ} </Table.Cell>
                    <Table.Cell width={6}> {item.status} </Table.Cell>
                    <Table.Cell width={5}> {item.description} </Table.Cell>
                  </Table.Row>
                );
              })}
            </Table.Body>
          </Table>
        </Table.Cell>
      ) : (
        <Table.Cell width={13}> {value} </Table.Cell>
      )}
    </Table.Row>
  );
};

const EMRRowSmoke = ({ name, value }) => {
  const intl = useIntl();
  const { smoke, smoke_freq, alcoholic_drink, alcoholic_drink_freq } = value;

  const checkFreq = (data:any) => {
    if (data === 1) {
      return "บางครั้ง"
    } else if (data === 2) {
      return "ประจำ"
    } else {
      return data
    }
  }

  return (
    <Table.Row key={name}>
      <Table.Cell width={3}>
        <Header as="h5"> {name} </Header>
      </Table.Cell>
      <Table.Cell width={13}>
        <label>
          {" "}
          <b>{intl.formatMessage({ id: "สูบบุหรี่" })}</b> {smoke} &ensp; &ensp;{checkFreq(smoke_freq)} &emsp; &emsp;
          <b>{intl.formatMessage({ id: "ดื่มสุรา" })}</b> {alcoholic_drink} &ensp; &ensp;{checkFreq(alcoholic_drink_freq)}
          {/* &emsp;&emsp;
          <b>{intl.formatMessage({ id: "การใช้สารเสพติด" })}</b>
          {""} &ensp; {" "} */}
        </label>
      </Table.Cell>
    </Table.Row>
  );
};

const EMRRowTextHTML = ({ name, value }) => {
  //
  let text = value.replace(/<[^>]+>/g, '')
  return (
    <Table.Row key={name}>
      <Table.Cell width={3}>
        <Header as="h5"> {name} </Header>
      </Table.Cell>
      <Table.Cell width={13}>
      {text}
      {/* <div className="content">{Parser(value)}</div> */}
      </Table.Cell>
    </Table.Row>
  );
};

const EMRRowText = ({ name, value }) => {
  // console.log('EMRRowText value: ', value);
  // console.log('EMRRowText name: ', name);
  return (
    <Table.Row key={name}>
      <Table.Cell width={3}>
        <Header as="h5"> {name} </Header>
      </Table.Cell>
      <Table.Cell width={13}>
        {typeof value === "string" && value.length > 0
          ? value.split("\n").map((i, key) => <p key={key}>{i}</p>)
          : Array.isArray(value) ? value.join(", ") : value}
      </Table.Cell>
    </Table.Row>
  );
};

const EMRRowCell = ({
  name,
  value,
}: {
  name: string;
  value: Record<string, any>[] | Record<string, any>[][];
}) => (
  <Table.Row key={name}>
    <Table.Cell width={3}>
      <Header as="h5"> {name} </Header>
    </Table.Cell>

    <Table.Cell style={{ padding: value.length === 0 ? "" : 0 }} width={13}>
      {value.length === 0 ? (
        "-"
      ) : (
        <Table style={{ backgroundColor: "transparent", border: "none" }}>
          <Table.Body>
            <Table.Row>
              {value.map((item, index) => (
                <Table.Cell
                  key={`cell-${index}`}
                  style={{
                    maxWidth: "95px",
                    minWidth: "95px",
                    textAlign: "center",
                    ...(name === "Vital sign" && { paddingBottom: "2px", paddingTop: "2px" }),
                  }}
                >
                  {Array.isArray(item) ? (
                    <>
                      <span style={{ color: item[0].color }}>{item[0].value}</span>
                      {"/"}
                      <span style={{ color: item[1].color }}>{item[1].value}</span>
                    </>
                  ) : (
                    <span style={{ color: item.color }}>{item.value}</span>
                  )}
                </Table.Cell>
              ))}
              <Table.Cell width={13} />
            </Table.Row>
          </Table.Body>
        </Table>
      )}
    </Table.Cell>
  </Table.Row>
);

const EMRRow = ({ emrSummary, emrArray }) => {
  const tableInvestigate = ["ผล Investigate ต่างๆ"];
  const tablePhysical = ["Physical Examination"];
  const combo = ["ประวัติสูบบุหรี่ /ประวัติดื่มสุรา"];
  const htmltag = ["Treatment"];
  return (
    <>
      {emrArray.map((item, index) => {
        if (tableInvestigate.includes(item)) {
          return (
            <EMRRowTable key={index} name={item} value={emrSummary[item]} />
          );
        } else if (tablePhysical.includes(item)) {
          // show Table
          return (
            <EMRRowTablePhysical
              key={index}
              name={item}
              value={emrSummary[item]}
            />
          );
        } else if (combo.includes(item)) {
          // Show combo
          return (
            <EMRRowSmoke key={index} name={item} value={emrSummary[item]} />
          );
        } else if (htmltag.includes(item)) {
          return <EMRRowTextHTML key={index} name={item} value={emrSummary[item]} />;
        } else if (Array.isArray(emrSummary[item])) {
          return <EMRRowCell key={index} name={item} value={emrSummary[item]} />;
        } else {
          // Show normal
          return <EMRRowText key={index} name={item} value={emrSummary[item]} />;
        }
      })}
    </>
  );
};

interface CardEMROPDSummaryProps {
  emrSummaryData?: Record<string,any>;
  patientPanelData?: Record<string, any>;
  closeable?: boolean;
  toggleable?: boolean;
  hideHeaderIcon?: boolean;
  getEMRSummaryData?: () => void;
  getEMRSummaryPrint?: () => void;
  onPrintEMRSummary?: () => void;
  onGetCheckupReportList?: (params: any) => CheckupReportSerializer[];
  onPrintMedicalReport?: (params: any) => void;
  isLoading?: boolean;
  masterOptions?: any;
}

const CardEMROPDSummary = ({
  emrSummaryData = {},
  patientPanelData = {},
  getEMRSummaryData = () => {},
  getEMRSummaryPrint = () => {},
  closeable = false,
  toggleable = false,
  hideHeaderIcon = true ,
  isLoading = false,
  onPrintEMRSummary = () => {},
  onGetCheckupReportList = (params: any) => [],
  onPrintMedicalReport = (params: any) => {},
  masterOptions = {},
}: CardEMROPDSummaryProps) => {

  // Don't change this key , it's very important on ภาษาไทย
  let emrArray = [
    "วันที่/เวลาที่เข้าพบแพทย์",
    "Vital sign",
    "Temperature",
    "Pulse",
    "Blood Pressure",
    "Respiratory Rate",
    "O2sat",
    "BMI",
    "ประวัติสูบบุหรี่ /ประวัติดื่มสุรา",
    "ประวัติการแพ้",
    "รายการยาที่ผู้ป่วยรับประทานอยู่ในปัจจุบัน",
    "Chief Complaint",
    // "โรคประจำตัว",
    // "ประวัติการทำผ่าตัด/หัตถการ",
    "Physician note (Present illness, Past history and relevant information)",
    "Past Illness",
    "Personal History",
    "Family History",
    "Physical Examination",
    // "Physical/General condition Signification Finding",
    "Diagnosis",
    "Medication",
    "Treatment",
    // "Surgical plan",
    "Appointment",
    "Discharge Status / Condition in case admit or transfer",
    "Patient and Family Education",
    "Barriers of data receiver",
    "Readiness and Willingness",
    "Teaching Method",
    "Education to",
    "Education Topic",
    "Physician",
    // "ผล Investigate ต่างๆ"
  ];

  let initSummary = emrArray.reduce((total, currentValue) => {
    let item = { [currentValue]: "N/A" };
    return { ...total, ...item };
  }, {});


  const [emrSummary, setEMRSummary] = useState(initSummary);
  const [isLoadingPrintReport, setIsLoadingPrintReport] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState<"th" | "en">("th");
  const [checkupReportList, setCheckupReportList] = useState<{ key: number | undefined; value: number | undefined; text: string }[]>([]);
  const [selectedCheckupReport, setSelectedCheckupReport] = useState<number | null>(null);
  const [isLoadingPrintCheckupReport, setIsLoadingPrintCheckupReport] = useState<boolean>(false);

  // useEffect(() => {
  //
  //   getEMRSummaryData();
  // }, []);

  useEffect(() => {
    if (emrSummaryData.hasOwnProperty("emr")) {
      let newEMRSummary = extractSummarytoState();
      setEMRSummary(newEMRSummary);
    } else {
      setEMRSummary(initSummary)
    }
  }, [emrSummaryData]);

  useEffect(() => {
    handleGetCheckupReportList();
  }, [emrSummaryData?.encounterId]);

  const isPackageEncounter = useMemo(() => {
    const currentPackageEncounter = patientPanelData.packageEncounters?.[emrSummaryData?.encounterId];
    const packageOrders = currentPackageEncounter?.package_orders || [];

    return (packageOrders.length > 0 && checkupReportList.length > 0) || false
  }, [patientPanelData, emrSummaryData, checkupReportList]);

  const getVitalSignData = ()=> {
    const items: any[] = emrSummaryData.vitalSign.items || [];

    items.reverse();

    let rowData = getTableRowVitalSign({
      ...emrSummaryData,
      vitalSign: items,
    });

    rowData = filterVitalSignTypeByAge(rowData, Number(emrSummaryData.emr[0].age_year));

    const formattedVitalSigns = items.map((vitalSignDataItem) => {
      const dateTime = formatDatetime(vitalSignDataItem.date_time_utc, true);
      const measurement_id = `${vitalSignDataItem.id}`;

      return {
        ...vitalSignDataItem,
        dateTime,
        measurement_id,
      };
    });

    const latestVitalSigns = formattedVitalSigns.slice(-3);

    const vitalSignTypes = ["DP", "SP", ["PULSE", "PR"], "RR", ["TEMP", "BT"], "O2Sat", "BMI"].map(
      (code) => code.toString().split(",")
    );

    const getVitalSignValues = (signType: string[]) => {
      const matchedRow = rowData.find((row) => signType.includes(row.code));
      const signValues = latestVitalSigns.map((vitalSign) => {
        const data = matchedRow?.[vitalSign.id || ""];

        return data
          ? {
              color: data.color,
              value: `${data.formatted_string} ${
                ["TEMP", "BT"].toString() === signType.toString() ? "°C" : ""
              }`,
            }
          : { color: "", value: "" };
      });

      return [signType[0], signValues];
    };

    const vitalSignData: Record<string, any[]> = Object.fromEntries(
      vitalSignTypes.map((signType) => getVitalSignValues(signType))
    );

    vitalSignData.VS = latestVitalSigns.map((item) => ({ value: item.dateTime }));

    return vitalSignData;
  }

  const extractSummarytoState = () => {
    const newEMRSummary: Record<string, any> = initSummary;
    // TODO: Check
    //ประวัติสูบบุหรี่ /ประวัติดื่มสุรา: "******** !!! !!****"

    if (emrSummaryData && emrSummaryData.emr) {
      emrSummaryData.emr[1].forEach((item, index) => {
        newEMRSummary[item.question] = item.answer;
      });

      newEMRSummary["O2sat"] = emrSummaryData.emr[0]["O2sat"];
      newEMRSummary["BMI"] = emrSummaryData.emr[0]["bmi"];
      newEMRSummary["Blood Pressure"] = emrSummaryData.emr[0]["blood_pressure"];
      newEMRSummary["Temperature"] = emrSummaryData.emr[0]["body_temperature"];
      newEMRSummary["Pulse"] = emrSummaryData.emr[0]["pulse"];
      newEMRSummary["Respiratory Rate"] =
        emrSummaryData.emr[0]["respiratory_rate"];

      let smoke = emrSummaryData.emr[0]["smoking"];
      let smoke_freq = emrSummaryData.emr[0]["smoking_freq"];
      let alcoholic_drink = emrSummaryData.emr[0]["alcoholic_drink"];
      let alcoholic_drink_freq = emrSummaryData.emr[0]["alcoholic_drink_freq"];

      newEMRSummary["ประวัติสูบบุหรี่ /ประวัติดื่มสุรา"] = {
        smoke,
        smoke_freq,
        alcoholic_drink,
        alcoholic_drink_freq
      };

      const sortedAdr = (emrSummaryData?.adverseReaction?.items || []).sort(
        (a, b) => SORT_ADR_ORDER[a.type_name_name] - SORT_ADR_ORDER[b.type_name_name]
      );
    
      newEMRSummary["ประวัติการแพ้"] = sortedAdr.map((acc) => acc.name as string).filter(Boolean).join(", ");
    }

    if (emrSummaryData?.vitalSign) {
      const vitalSignData = getVitalSignData();

      newEMRSummary["Vital sign"] = vitalSignData.VS;
      newEMRSummary.O2sat = vitalSignData.O2Sat;
      newEMRSummary.BMI = vitalSignData.BMI;
      newEMRSummary["Blood Pressure"] = vitalSignData.SP.map((_, index) => [
        vitalSignData.SP[index],
        vitalSignData.DP[index],
      ]);
      newEMRSummary.Temperature = vitalSignData.TEMP;
      newEMRSummary.Pulse = vitalSignData.PULSE;
      newEMRSummary["Respiratory Rate"] = vitalSignData.RR;
    }

    return newEMRSummary;
  };

  const handlePrint = param => {
    getEMRSummaryPrint();
  };

  const handlePrintReport = async () => {
    if (isLoadingPrintReport) {
      return;
    }

    setIsLoadingPrintReport(true);

    await onPrintEMRSummary({ emrArray, emrSummary, emrSummaryData });

    setIsLoadingPrintReport(false);
  };

  const handleGetCheckupReportList = async () => {
    const list = await onGetCheckupReportList({ emrSummaryData });

    const formatList = (list || []).map((item: CheckupReportSerializer) => ({
      key: item.id,
      value: item.id,
      text: `Checkup Report: ${item.id}`
    }));

    setCheckupReportList(formatList);
  };

  const handlePrintMedicalReport = async () => {
    if (!selectedCheckupReport) {
      alert("กรุณาเลือกสมุดตรวจสุขภาพ");
      return;
    }

    if (isLoadingPrintCheckupReport) {
      return;
    }

    setIsLoadingPrintCheckupReport(true);

    await onPrintMedicalReport({ emrSummaryData, language: selectedLanguage, selectedCheckupReport, masterOptions });

    setIsLoadingPrintCheckupReport(false);
  };

  const handleChangeData = (_event: any, data: any) => {
    const name = data.name;
    const value = data?.value;

    if (name === "language") setSelectedLanguage(value);
    if (name === "checkup_report") setSelectedCheckupReport(value);
  };

  console.log("Card OPD Summary: ", { emrSummaryData, patientPanelData, isPackageEncounter, checkupReportList });

  return (
    <CardLayout
      titleText="EMR Summary"
      closeable={closeable}
      toggleable={toggleable}
      hideHeaderIcon={hideHeaderIcon}
    >
      <Dimmer active={isLoading} inverted>
        <Loader />
      </Dimmer>

      <Form
        size="mini"
        style={{
          display: emrSummaryData.encounterType === "OPD" ? "" : "none",
          position: "absolute",
          left: "10.5rem",
          top: "8px"
        }}>
        <FormGroup inline>
          <FormField inline style={{ display: "flex", gap: "0.5rem" }}>
            <Dropdown
              name="language"
              onChange={handleChangeData}
              options={LANGUAGE_OPTIONS}
              selection
              fluid
              value={selectedLanguage}
            />

            <Button
              color="green"
              size="mini"
              loading={isLoadingPrintReport}
              onClick={handlePrintReport}
            >
              <Icon name="print" />
              OPD Report
            </Button>

            {isPackageEncounter && (
              <>
                <Dropdown
                  name="checkup_report"
                  placeholder="Select Medical Report"
                  onChange={handleChangeData}
                  options={checkupReportList}
                  selection
                  value={selectedCheckupReport as number}
                />

                <Button
                  color="yellow"
                  size="mini"
                  loading={isLoadingPrintCheckupReport}
                  onClick={handlePrintMedicalReport}
                >
                  <Icon name="print" />
                  Medical Report
                </Button>

                <Button
                  color="purple"
                  size="mini"
                  onClick={() => console.log("Send to Mobile is not available yet")}
                >
                  <Icon name="mobile alternate" />
                  Send to Mobile
                </Button>
              </>
            )}
          </FormField>
        </FormGroup>
      </Form>

      {emrSummaryData.hasOwnProperty("emr") || emrSummaryData.hasOwnProperty("success") ? (
        <>
          {/* <div style={{ textAlign: "right" }}>
            <Button
              size="tiny"
              color="teal"
              content={intl.formatMessage({ id: "พิมพ์" })}
              icon="print"
              labelPosition="left"
              onClick={handlePrint}
            />
          </div> */}
          <Table striped celled size="small">
            <Table.Body>
              <EMRRow emrSummary={emrSummary} emrArray={emrArray} />
            </Table.Body>
          </Table>
        </>
      ) : null}
    </CardLayout>
  );
};

export default CardEMROPDSummary;
